import type { ReactNode } from 'react';
import type { CockpitKitView } from '@nest-recruit/shared';
import { Drawer } from '../../../components/Drawer';
import { KitQuestionList } from '../../../components/KitQuestionList';
import styles from '../pages/Cockpit.module.css';

interface KitSheetProps {
  readonly kit: CockpitKitView | null;
  readonly isOpen: boolean;
  readonly onClose: () => void;
}

/**
 * INT-02 — the round's interview kit as a side sheet (F11.09): its questions in the kit's order, under the line of the kit's
 * own rubric each was written for. Nothing here is marked: one overall mark (ADR 0077). The kit editor's preview draws the
 * same list (admin redesign batch 2).
 */
export function KitSheet({ kit, isOpen, onClose }: KitSheetProps): ReactNode {
  const questions = kit?.questions.map((question) => ({ id: question.id, text: question.text, guidance: question.guidance, topic: question.topic })) ?? [];
  return (
    <Drawer isOpen={isOpen} onClose={onClose} title="Interview kit" meta={kit?.name ?? 'No kit on this round'}>
      {questions.length === 0 ? <p className={styles.quiet}>This round has no suggested questions.</p> : <KitQuestionList questions={questions} />}
    </Drawer>
  );
}
